<template>
  <div class="login">
    <div class="alert" v-if="showAccountCreatedBanner">
      <ul><li>登録ができました！ログインしましょう。</li></ul>
    </div>

    <Form @submit="() => {}">
      <Input
        name="username"
        v-model="username"
        type="text"
        as="input"
        rules="required|email"
        label="メールアドレス"
        :have-error-display="false"
        :key="manualChange"
        :dont-show-required="true"
      />

      <Input
        name="password"
        v-model="password"
        type="password"
        placeholder="パスワードを入力してください"
        as="input"
        rules="required"
        label="パスワード"
        :have-error-display="false"
        :dont-show-required="true"
      />

      <div class="button-container">
        <Button @click="login" color="gold">ログイン</Button>
      </div>
    </form>

    <div class="link">
      <a href="/newUser">アカウントを作成する</a>
    </div>
    <div class="line" />
    
    <div class="link">
      <a href="https://my-lancul.com/members/password/remind/mail">パスワードをお忘れの方</a>
    </div>
    <div class="link">
      <a href="https://my-lancul.com/members/password/remind/id/">メールアドレスをお忘れの方</a>
    </div>
    <div class="line" />

    <div class="link">
      <a href="https://trial.lancul.com">LanCulを初めて利用される方</a>
    </div>
  </div>
</template>

<script>
import { authenticate } from '@/api/authenticate.js'
import { Form } from 'vee-validate';
import Button from '@/components/signup/Button.vue'
import Input from '@/components/signup/Input.vue'

export default {
  name: 'Login',

  components: {
    Form,
    Button,
    Input
  },

  props: {
    userId: {
      type: String
    },

    deviceInfo: {
      type: String,
      required: true
    },

    deviceId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      username: '',
      password: '',
      manualChange: 0,
      showAccountCreatedBanner: false
    }
  },

  mounted() {
    if (this.userId) {
      this.username = this.userId
      this.showAccountCreatedBanner = true
      this.manualChange += 1
    }
  },

  watch: {
    userId() {
      // console.log("watched")
      if (this.userId) {
        this.username = this.userId
      }
    }
  },

  methods: {
    async login() {
      this.$emit('processing', true)
      const {accepted, loginToken, message} = await authenticate({
        username: this.username,
        password: this.password,
        deviceInfo: this.deviceInfo,
        deviceId: this.deviceId
      })
      this.$emit('processing', false)
      if (accepted === "1") {
        this.$emit('loggedIn', this.username, loginToken)
      } else {
        this.$emit('alert', "Error", message)
      }
    }
  }
}
</script>

<style scoped>
.login {
  padding: 70px 20px 0;
}

.login .alert {
  background-color: #fff;
  margin-bottom: 54px;
  padding: 6px 4px;
  border: 1px solid black;
  box-sizing: border-box;
}

.login .alert ul {
  padding-left: 20px;
}

.login .alert ul li {
  list-style-type: square;
  color: black;
}

.login .input {
  margin-bottom: 20px;
}

.login .button-container {
  margin: 50px 0 60px;
  display: flex;
  justify-content: center;
}

.login button {
  font-size: 15px;
  line-height: 22.5px;
  font-weight: 700;
  border-radius: 4px;
  letter-spacing: 1.12px;
  color: #FFAE00;
  background-color: white;
  border: 1px solid #FFAE00;
}

.login .link {
  display: flex;
  justify-content: center;
  margin: 10px 0;
}

.login .link a {
  color: #999;
  font-size: 12px;
  line-height: 18px;
}

.login .line {
  height: 1px;
  background-color: #B6B6B6;
  opacity: 0.5;
}
</style>
